import React from 'react'
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Typography,
  Box,
  Icon,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import './AccordionItemCustom.scss'

/**
 * AccordionItemCustom – MUI version of Pepsico-DS AccordionItem.
 * Provides a drop-in replacement for new development while keeping legacy component intact.
 */
function AccordionItemCustom({
  presentation = 'box-shadow',
  content = null,
  children,
  isDark = false,
  disabled = false,
  expanded = false,
  icon,
  avatar,
  label = '',
  size = 'medium',
  labelClassName,
  subTitle = '',
  imageUrl = '',
  showSkeleton = false, // not implemented, left for future enhancement
  index,
  onUpdate = () => {},
  rightAccessoryChild,
  className,
  style,
}) {
  // Local expanded state if not fully controlled
  const [open, setOpen] = React.useState(expanded)

  const handleChange = (_, isExpanded) => {
    setOpen(isExpanded)
    onUpdate(index)
  }

  const summaryContent = (
    <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
      {avatar && <Avatar src={imageUrl} sx={{mr: 1}}>{avatar}</Avatar>}
      {icon && !avatar && (
        <Icon sx={{mr: 1}} fontSize="small">
          {icon}
        </Icon>
      )}
      <Box sx={{flexGrow: 1}}>
        <Typography component="div" variant="body1" className={labelClassName}>
          {label}
        </Typography>
        {subTitle && (
          <Typography component="div" variant="caption" color="text.secondary">
            {subTitle}
          </Typography>
        )}
      </Box>
      {rightAccessoryChild && <Box ml={1}>{rightAccessoryChild}</Box>}
    </Box>
  )

  return (
    <MuiAccordion
      disabled={disabled || showSkeleton}
      expanded={open}
      onChange={handleChange}
      elevation={presentation === 'box-shadow' ? 1 : 0}
      square
      className={[
        'accordion-item-wrapper',
        isDark ? 'dark' : 'light',
        presentation && `presentation-${presentation}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={style}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="accordion-icon" />}
        className="accordion-summary"
      >
        {summaryContent}
      </AccordionSummary>
      <AccordionDetails className="accordion-details">{content || children}</AccordionDetails>
    </MuiAccordion>
  )
}

export default AccordionItemCustom 